import React from "react";
import Arrow from "../../shared/arrow";
import "./style.scss";

const BlogCard = ({ user, date, image, title, description, link }) => {
    const handleReadMoreClick = () => {
        window.open(link, "_blank");
    };

    const buttonStyle = {
        color: "white",
        backgroundColor: "#0D2636",  // Set the background color to red
        border: "#E84C88",
        padding: "10px 20px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        display: "inline-flex",   // Use inline-flex for horizontal alignment of icon
        alignItems: "center",    // Center items vertically in the button
    };

    return (
        <div className="blog-card">
            <div className="image-section">
                <img
                    src={image}
                    alt={title}
                />
            </div>
            <div className="content-section">
                <div className="info-bar">
                    <div className="user-name">By {user}</div>
                    <div className="posted-date">{date}</div>
                </div>
                <h3>{title}</h3>
                <p>{description}</p>
                <div className="readmore-cta">
                    {/* Apply inline styles to the button section */}
                    <button style={buttonStyle} onClick={handleReadMoreClick}>
                        Read More <Arrow />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;
